// apps/web/src/lib/omie-erro-api.ts — Fase 17.1, Plano 25 (L-60, T-17.1-25-04).
// `apiFetch` lança Error com o CORPO CRU da resposta (ex.: {"message":"Sem permissão para este recurso.","statusCode":403}).
// Esta função devolve só o texto em português para a tela: nunca JSON cru e nunca o "Forbidden resource" em inglês do Nest.
export const MENSAGEM_SEM_PERMISSAO_OMIE = 'Você não tem permissão para ver ou executar esta ação da integração Omie.';

function primeiroTexto(valor: unknown): string | null {
  if (typeof valor === 'string' && valor.trim() !== '') return valor;
  if (Array.isArray(valor)) {
    const texto = valor.find((item): item is string => typeof item === 'string' && item.trim() !== '');
    return texto ?? null;
  }
  return null;
}

export function mensagemLegivelDoErro(causa: unknown, padrao: string): string {
  const bruto = causa instanceof Error ? causa.message.trim() : '';
  if (bruto === '') return padrao;
  let texto: string | null = bruto;
  if (bruto.startsWith('{') || bruto.startsWith('[')) {
    try {
      const corpo = JSON.parse(bruto) as unknown;
      texto = corpo && typeof corpo === 'object' ? primeiroTexto((corpo as Record<string, unknown>).message) : null;
    } catch {
      texto = null;
    }
  }
  if (texto === null) return padrao;
  if (/^forbidden resource$/i.test(texto)) return MENSAGEM_SEM_PERMISSAO_OMIE;
  return texto;
}
